import Demo, { DemoSliderControl } from '@/components/Demo';

import InitialCurve from './InitialCurve';

function InitialCurveDemo() {
  return (
    <Demo
      id="initial-curve"
      initialValues={{
        percentStraightened: 0,
      }}
      controls={[
        <DemoSliderControl
          key="percentStraightened"
          id="percentStraightened"
          label="Percent Straightened"
          min={0}
          max={100}
        />,
      ]}
    >
      {({ percentStraightened }) => {
        return (
          <InitialCurve
            percentStraightened={percentStraightened}
            color="var(--color-primary)"
          />
        );
      }}
    </Demo>
  );
}

export default InitialCurveDemo;
